import { z } from "zod";
import { NOTIFICATION_CHANNELS, NOTIFICATION_EVENT_KEYS } from "../domain";

// Phase 7 sub-bucket 7 — single-cell upsert body for the /portal/settings
// notification-preferences toggle grid. The GET response is just an array of
// these (server pre-realizes the 32-cell matrix; missing rows default to
// enabled). See supabase/migrations/0070_notification_preferences.sql.

export const notificationPreferenceCellSchema = z.object({
  event_key: z.enum(NOTIFICATION_EVENT_KEYS as readonly [string, ...string[]]),
  channel: z.enum(NOTIFICATION_CHANNELS as readonly [string, ...string[]]),
  enabled: z.boolean(),
});
export type NotificationPreferenceCell = z.infer<
  typeof notificationPreferenceCellSchema
>;
